import React from 'react';

// Zoom-Regler nach Canva-Vorbild: Minus, Schieber, Plus, Prozentanzeige und ein Knopf,
// der wieder auf „passt ins Fenster" zurückstellt.
//
// `wert` ist immer der tatsächliche Maßstab des Blattes — 100 % heißt Originalgröße wie
// auf Papier, egal ob die Zahl gerade von der automatischen Einpassung kommt oder vom
// User. `auto` sagt nur, wer sie im Moment bestimmt.

// Grenzen auf Ansage des Users am 2026-08-11: Darunter ist nichts mehr zu lesen,
// darüber sieht man nur noch Ausschnitte.
export const ZOOM_MIN = 0.55;
export const ZOOM_MAX = 1.5;

export const zoomKlemmen = (v) => Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, v));

export default function ZoomRegler({ wert, auto, onZoom, onAuto }) {
  const prozent = Math.round(wert * 100);
  return (
    <div className="se-zoom" role="group" aria-label="Zoom">
      <button
        type="button" className="se-zoom-btn" aria-label="Verkleinern"
        disabled={wert <= ZOOM_MIN}
        onClick={() => onZoom(zoomKlemmen(wert - 0.1))}
      >−</button>

      {/* ponytail: natives <input type="range"> statt eigener Schieber-Logik */}
      <input
        type="range" className="se-zoom-schieber" aria-label="Zoomstufe"
        min={ZOOM_MIN * 100} max={ZOOM_MAX * 100} step={5} value={prozent}
        onChange={(e) => onZoom(zoomKlemmen(Number(e.target.value) / 100))}
      />

      <button
        type="button" className="se-zoom-btn" aria-label="Vergrößern"
        disabled={wert >= ZOOM_MAX}
        onClick={() => onZoom(zoomKlemmen(wert + 0.1))}
      >+</button>

      <span className="se-zoom-wert">{prozent}%</span>

      <button
        type="button"
        className={`se-zoom-fit${auto ? ' aktiv' : ''}`}
        onClick={onAuto}
        title="An Fenster anpassen (Strg + Mausrad zoomt)"
      >Anpassen</button>
    </div>
  );
}
